import Mutations from "./board-mutations";
import Actions from "./board-actions";
import Getters from "./board-getters";
import DefaultState from "./board-default-state";
const BoardStore = {
  namespaced: true,
  state: DefaultState,
  mutations: Mutations,
  actions: Actions,
  getters: Getters
};
export default BoardStore;